import type { StepConfigItem } from './types';

export const customV78: StepConfigItem[] = [
  {
    name: 'start_page_age',
    hideProgress: true,
    progressTitle: 'customV2_progress_text1',
  },
  {
    name: 'customV2_policyPageV4',
    hideHeader: true,
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_info_breed',
    separationStep: true,
    hideHeader: true,
    progressTitle: 'customV2_progress_text2',
  },
  {
    name: 'behavior_concern',
  },
  {
    name: 'stranger_reaction',
  },
  {
    name: 'leash_behavior',
  },
  {
    name: 'resource_guarding',
  },
  {
    name: 'aggression_history',
  },
  {
    name: 'ignore_commands',
  },
  {
    name: 'k9_goal',
  },
  {
    name: 'k9_info_personalization',
    separationStep: true,
    hideHeader: true,
    progressTitle: 'customV2_progress_text3',
  },
  {
    name: 'customV2_command_1',
  },
  {
    name: 'customV2_reason',
  },
  {
    name: 'customV2_date',
  },
  {
    name: 'customV2_info_predict',
    hideHeader: true,
  },
  {
    name: 'customV2_training_time',
  },
  {
    name: 'customV2_training',
  },
  {
    name: 'age_group',
  },
  {
    name: 'customV2_creating_program',
    hideProgress: true,
  },
  {
    name: 'customV2_plan',
    hideProgress: true,
  },
  {
    name: 'customV2_email',
    hideProgress: true,
  },
  {
    name: 'receive_email',
    hideProgress: true,
  },
  {
    name: 'customV2_specialOffer_v4',
    hideProgress: true,
  },
];
